module.exports = __webpack_public_path__ + "img/ic_bound.8b42d3a1.png";